import React from 'react'

import TextField from 'material-ui/TextField'

const EarlyBirdPricingStrategy = props => {
  const { configuration, onValueChange } = props

  const onPriceChange = e => {
    onValueChange(e, 'price', e.target.value)
  }

  return (
    <div>
      <TextField
        floatingLabelText='Price'
        value={configuration.price}
        onChange={onPriceChange}
      />
    </div>
  )
}

// @ts-ignore
EarlyBirdPricingStrategy.propTypes = {
  configuration: React.PropTypes.object.isRequired,
  onValueChange: React.PropTypes.func.isRequired
}

export default EarlyBirdPricingStrategy
